export const setWidgetCache = (data) => {
   return {
      type: "SET_WIDGET_CACHE",
      payload: data
   };
};
